import { useCallback, useEffect, useMemo, useState } from 'react'

import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom'

import { FaSearch } from 'react-icons/fa'
import { IoClose }  from 'react-icons/io5'
import { IoMenu }   from 'react-icons/io5'

import CartCountIcon from './CartCountIcon'
import UserMenu      from '../UserMenu'
import Spinner       from '../../Spinners/Spinner'

import Logo from '../../Pure/Logo'

import bemit from '../../Functions/bemit'

import AccountStore from '@Stores/Account'
import NavbarStore  from '@Stores/Navbar'
import RolesStore   from '@Stores/Roles'

export default function FrontHeader ({ ...props })
{
	const [searchValue, setSearchValue] = useState('');
	const [mobile_open, setMobileOpen] = useState(false);
	const [searchbar_loading, setSearchbarLoading] = useState(false);

	const location = useLocation();

	useEffect(() =>
	{
		setMobileOpen(false);
		setSearchbarLoading(false);
	},
	[location.pathname]);

	const sub_families = NavbarStore.useState(s => s.sub_families);

	const user_roles = RolesStore.useState(s => s.roles);

	const is__auth = user_roles?.length && !user_roles.includes('guest');

	const code_client = AccountStore.useState(s => s.code_client);

	const navigate = useNavigate();

	const handleChange = useCallback(function (e)
	{
		setSearchValue(e.target.value);
	},
	[]);

	const searchArticle = useCallback(function (e)
	{
		let code_article = encodeURIComponent(
			document.getElementById('search').value || ''
		);

		const new_path = '/recherche/' + code_article;

		if (new_path !== location.pathname)
		{
			setSearchbarLoading(true);

			navigate(new_path);
		}
		else
		{
			window.location.reload();
		}
	},
	[navigate, location.pathname]);

	const handleSearchKeyDown = useCallback(function (e)
	{
		if (['Enter', 'NumpadEnter'].includes(e.code))
		{
			searchArticle();
		}
	},
	[searchArticle]);

	const families_links = useMemo(function ()
	{
		return (sub_families || []).map(function (sub_family)
		{
			const url = '/articles/' + encodeURIComponent(sub_family);

			return (
				<li key={ sub_family } className="c-navbar__item">
					<NavLink to={ url } className="c-navbar__item-link">
						{ sub_family }
					</NavLink>
				</li>
			)
		})
		.filter(item => item);
	},
	[sub_families]);

	const navbar = useMemo(function ()
	{
		if (!families_links?.length) return null;

		return (
			<nav className={ bemit('c-navbar', mobile_open ? ['open'] : []) }>
				<ul className="c-navbar__list">
					{ families_links }
				</ul>
			</nav>
		);
	},
	[families_links, mobile_open]);

	const toggleOpen = useCallback(function (e)
	{
		setMobileOpen(open => !open);
	},
	[]);

	const modifiers = useMemo(function ()
	{
		return [].concat(mobile_open ? ['open'] : [])
	},
	[mobile_open]);

	const ToggleIcon = mobile_open ? IoClose : IoMenu;

	const entite_name = !code_client
	? undefined
	: code_client.startsWith('B')
	? 'BEROKI'
	: code_client.startsWith('L')
	? 'LTF'
	: code_client.startsWith('C')
	? 'C2Clim'
	: null;

	return (
		<header className={ bemit('c-header', modifiers) }>

			<div className="o-container c-header__container">

				<Link to="/" className="c-header__title-link">
					<Logo className="c-header__logo" />
					<div className="c-header__title">
						Spécialistes Chauffage Climatisation depuis + de 40 ans
					</div>
				</Link>

				<div className="c-header__searchbar-div">
					<input type="text"
						placeholder={ is__auth
						? 'Recherche par code ou nom d\'article'
						: 'Connectez-vous pour utiliser la recherche' }
						value={ searchValue }
						onChange={ handleChange }
						onKeyDown={ handleSearchKeyDown }
						id="search"
						className="c-header__searchbar"
						disabled={ !is__auth }
					/>
					<button onClick={ searchArticle }
						type="button"
						className="c-header__searchbtn"
						disabled={ !is__auth }>
						<FaSearch />
					</button>
					<Spinner active={ searchbar_loading }
						bemit={ ['primary', 'bg-white'] }
					/>
				</div>

				{
					user_roles.includes('contact') && entite_name ?
					(
						<div className="c-header__user">

							<span className="c-header__user-agence">
								Votre agence&nbsp;:
								{ ' ' }
								{ entite_name }
							</span>

							<CartCountIcon />

						</div>
					)
					: undefined
				}

				<UserMenu />

				<button type="button" onClick={ toggleOpen }
					className="c-header__mobile-toggle">
					<ToggleIcon className="c-header__mobile-toggle-icon" />
					<span className="c-header__mobile-toggle-text">
						{
							mobile_open
							? 'Fermer'
							: 'Menu'
						}
					</span>
				</button>

			</div>

			{ navbar }

		</header>
	);
}